import site from "../../content/site.json";
import horse from "../../content/horse.json";
import faq from "../../content/faq.json";
import races from "../../content/races.json";
import membersSeed from "../../content/members-seed.json";
import legal from "../../content/legal.json";

export { site, horse, faq, races, membersSeed, legal };

export function formatGBP(n: number): string {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: n % 1 === 0 ? 0 : 2,
  }).format(n);
}

export function formatDate(iso: string): string {
  try {
    return new Intl.DateTimeFormat("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function tierPrice(t: { buyIn?: number | null; pcm?: number | null; feeLabel?: string }): { amount: number; suffix: string } {
  const buyIn = t.buyIn != null ? Number(t.buyIn) : NaN;
  if (Number.isFinite(buyIn) && buyIn > 0) return { amount: buyIn, suffix: " buy-in" };
  const pcm = t.pcm != null ? Number(t.pcm) : NaN;
  if (Number.isFinite(pcm) && pcm > 0) return { amount: pcm, suffix: " / mo" };
  return { amount: 0, suffix: "" };
}

export function tiersCardsHtml(): string {
  return site.tiers
    .map((t) => {
      const sharePercent = Number((t as { sharePercent: number }).sharePercent);
      const buyIn = Number((t as { buyIn?: number | null }).buyIn ?? 0);
      const pcm = Number((t as { pcm?: number | null }).pcm ?? 0);
      const highlight = Boolean((t as { highlight?: boolean }).highlight);
      const priceLine =
        buyIn > 0 && pcm > 0
          ? `${formatGBP(buyIn)}<span style="font-size:0.9rem;font-weight:600;color:var(--pota-muted)"> buy-in</span><br/><span style="font-size:1.1rem">${formatGBP(pcm)}</span><span style="font-size:0.85rem;font-weight:600;color:var(--pota-muted)"> / mo keep</span>`
          : buyIn > 0
            ? `${formatGBP(buyIn)}<span style="font-size:0.9rem;font-weight:600;color:var(--pota-muted)"> buy-in</span>`
            : `${formatGBP(pcm)}<span style="font-size:0.9rem;font-weight:600;color:var(--pota-muted)"> / mo</span>`;
      return `
    <article class="card card--lift"${highlight ? ' style="border-color:var(--pota-secondary)"' : ""}>
      <div class="card__eyebrow">${highlight ? "Featured" : "Share tier"}</div>
      <h3 style="margin:0.25rem 0">${t.label}</h3>
      <p style="font-family:var(--font-display);font-size:1.75rem;font-weight:600;margin:0.35rem 0;line-height:1.25">${priceLine}</p>
      <p style="margin:0;color:var(--pota-muted);font-size:0.95rem">Prize money annually by ${sharePercent}%</p>
    </article>`;
    })
    .join("");
}
